import { render, staticRenderFns } from "./ListarSecciones.vue?vue&type=template&id=2c0d2c00&"
import script from "./ListarSecciones.vue?vue&type=script&lang=js&"
export * from "./ListarSecciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports